export default "__VITE_PUBLIC_ASSET__134b22dc__"